import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=344be951"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports